var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bubble-chart__tooltip",style:({
    top: (_vm.top + "px"),
    left: (_vm.left + "px"),
    visibility: _vm.value ? 'visible' : 'hidden',
  })},[_c('span',{staticClass:"bubble-chart__tooltip-text",domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }